module.exports = "img/flags/MG.729aba3.png";